import React, { useEffect, useMemo, useState } from 'react';
import GenericModal from '../../../components/agv-generic-modal';
import ConsignmentRuleFormFields, {
  buildConsignmentRulePayload,
  isConsignmentRuleFormValid,
} from './consignment-rule-form-fields';
import { CONSIGNMENT_RULE_TYPES } from '../../../utils/consignment-rule.util';

export default function ConsignmentRuleCreateModal({
  isOpen,
  setIsOpen,
  createConsignmentRule,
  mainActionIsLoading,
  packagingOptions,
}) {
  const [itemKey, setItemKey] = useState('');
  const [packagingId, setPackagingId] = useState(null);
  const [ruleType, setRuleType] = useState(CONSIGNMENT_RULE_TYPES.LINE_DIRECT);
  const [fixedQuantity, setFixedQuantity] = useState('');
  const [weightDivisor, setWeightDivisor] = useState('');
  const [weightUnit, setWeightUnit] = useState('kg');
  const [isActive, setIsActive] = useState('true');

  const isValid = useMemo(
    () =>
      isConsignmentRuleFormValid({
        itemKey,
        packagingId,
        ruleType,
        fixedQuantity,
        weightDivisor,
        weightUnit,
      }),
    [itemKey, packagingId, ruleType, fixedQuantity, weightDivisor, weightUnit]
  );

  useEffect(() => {
    if (!isOpen) {
      setItemKey('');
      setPackagingId(null);
      setRuleType(CONSIGNMENT_RULE_TYPES.LINE_DIRECT);
      setFixedQuantity('');
      setWeightDivisor('');
      setWeightUnit('kg');
      setIsActive('true');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    createConsignmentRule(
      buildConsignmentRulePayload({
        itemKey,
        packagingId,
        ruleType,
        fixedQuantity,
        weightDivisor,
        weightUnit,
        isActive,
      })
    );
  };

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Créer une règle de consigne'}
      mainAction={handleSubmit}
      mainActionText={'Créer'}
      mainActionIsLoading={mainActionIsLoading}
      mainActionDisabled={!isValid}
    >
      <ConsignmentRuleFormFields
        itemKey={itemKey}
        setItemKey={setItemKey}
        packagingId={packagingId}
        setPackagingId={setPackagingId}
        ruleType={ruleType}
        setRuleType={setRuleType}
        fixedQuantity={fixedQuantity}
        setFixedQuantity={setFixedQuantity}
        weightDivisor={weightDivisor}
        setWeightDivisor={setWeightDivisor}
        weightUnit={weightUnit}
        setWeightUnit={setWeightUnit}
        isActive={isActive}
        setIsActive={setIsActive}
        packagingOptions={packagingOptions}
        mode="create"
      />
    </GenericModal>
  );
}
